export default ({ store }) => {
  // 确保只在客户端执行
  if (process.client) {
    // 从 sessionStorage 中获取存储的状态
    const savedState = sessionStorage.getItem('ui-portal-state');
    if (savedState) {
      try {
        const { user, devSearch, breadcrumbs } = JSON.parse(savedState);
        // 恢复所有缓存数据
        // store.commit('SET_USER', user);
        store.commit('devSearch/SET_ITEM', devSearch?.devSearchItem ?? {});
        store.commit('SET_BREADCRUMBS', breadcrumbs ?? []);
        // store.replaceState(JSON.parse(savedState));
        console.log('已从缓存恢复状态');
      } catch (error) {
        console.error('解析缓存状态时出错:', error);
      }
    }
  }
};
